import { useContext } from 'react';
import ApiClient from '@lib/apiClient';
import { ApiClientContext } from '@components/ApiClientProvider';

function useApiClient(): ApiClient {
  return useContext(ApiClientContext);
}

export default useApiClient;
